<template>
  <div class="text-title">
    <img src="../assets/images/textr.png"
         alt="">
    <span class="text"
          v-bind:style="{ color: activeColor, fontSize: fontSize + 'rem' }">{{activeText}}</span>
    <img src="../assets/images/textl.png"
         alt="">
  </div>
</template>
<script>
export default {
  props: {
    activeColor: {
      type: String,
      default: ''
    },
    activeText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fontSize: 0.48
    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style  scoped>
.text-title {
  text-align: center;
}
.text {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(41, 51, 51, 1);
  vertical-align: middle;
  margin: 0 10px;
}
</style>